export const Gender = ({ icon, text, isSelected, onClick }) => {
  return (
    <div
      onClick={() => onClick(text)}
      className={`w-[100px] rounded-[20px] bg-[#0075FF1A] pb-[17px] pt-[22px] ${
        isSelected
          ? "border-[1.5px] border-[#0075FF]"
          : "border-[1.5px] border-transparent transition-all"
      }`}
    >
      <div
        className={`mb-[14px] flex items-center justify-center text-center ${isSelected ? "text-[#0075FF]" : "text-black"}`}
      >
        {icon}
      </div>

      <p
        className={`text-center font-outfit text-[12px] font-medium leading-[15.12px] ${isSelected ? "text-[#0075FF]" : "text-black"}`}
      >
        {text}
      </p>
    </div>
  );
};
